"use strict";

import axios from "axios";
import Vue from "vue";

const urls = {
  // hub url
  protocol: {
    production: "/m3dhub/soap/api", // 같은 호스트의 nginx 가 /m3dhub/soap 를 dev API 로 프록시(dev.m3d.kr·spark 공통). 로컬 미리보기는 .env.local 의 VUE_APP_API_BASE 로 지정
    development:
      "http://localhost:3008/api", // 개발환경
  },

};
// 현재 환경변수를 통한 url
const baseURL = process.env.VUE_APP_API_BASE ||
  urls[process.env.VUE_APP_PROTOCOL ? "protocol" : "note"][
    process.env.NODE_ENV
  ];
console.log("%caxios.js", "color: #007acc;", process.env.NODE_ENV, baseURL);

let config = {
  baseURL: baseURL,
  timeout: 300 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default _axios;
